import { graphql, useStaticQuery } from 'gatsby';

interface Image {
  childImageSharp: {
    fluid: {
      src: string;
    };
  };
}
interface Item {
  id: string;
  image: Image;
}
interface OnboardingState {
  onboarding: Item;
  items: Item[];
}
export const useOnboarding = (): OnboardingState => {
  const { dataJson } = useStaticQuery(
    graphql`
      query {
        dataJson {
          onboarding {
            id
            image {
              childImageSharp {
                fluid(maxWidth: 700) {
                  src
                }
              }
            }
          }
          items {
            id
            image {
              childImageSharp {
                fluid(maxWidth: 700) {
                  src
                }
              }
            }
          }
        }
      }
    `
  );
  return dataJson;
};
